import BottomSheet from './BottomSheetReactionAddon';
import Message from './MessageReactionAddon';

export const ReactionAddons = {
  BottomSheet,
  Message,
};
